import { createApi } from '@/api'
export default {
  install(app, axios) {
    app.config.globalProperties.$api = createApi(axios)
  },
}
